import { Transforms, Node } from 'slate'
import { Registry } from '@react-registry'

import { removeRow } from '../utils/gridActions'
import { ElementWithType } from '../../../../../../../utils/types';

export const withGrid = (editor) => {
    const { normalizeNode, apply } = editor;

    editor.normalizeNode = (entry) => {
        const [node, path] = entry;

        if (node.type === 'column' && node.meta.width === 1) {
            removeRow(editor, path);
            return;
        }

        if (node.type === 'column' && node.children.length === 0) {
            const rowPath = path.slice(0, path.length - 1);


            Transforms.removeNodes(editor, {
                at: path
            })

            const updatedRow: any = Node.get(editor, rowPath);


            // first case: only single element left
            if (updatedRow.children.length === 1) {
                removeRow(editor, path);
            }
            return;
        }
        // row with only text gets deleted
        const isRowWithNoColumn = (
            node.type === 'row' && node.children.length === 1 &&
            node.children[0].text === '' && node.children[0].type === undefined
        );
        if (isRowWithNoColumn) {
            Transforms.removeNodes(editor, {
                at: path
            })
        }
        return normalizeNode(entry)
    }

    editor.apply = operation => {
        if (operation.type === 'remove_node' && operation.node.type === 'column') {
            const { path } = operation;
            const rowPath = path.slice(0, path.length - 1);
            const row: any = Node.get(editor, rowPath);
            if (row.type === 'row') {
                const removingCol: any = Node.get(editor, path);
                const removingColWidth = removingCol?.meta?.width;
                const newColCount = row.children.length - 1;
                const widthToBeAdded = removingColWidth / newColCount;

                row.children.forEach((child, index) => {
                    if (child.children.length !== 0) {

                        Transforms.setNodes(editor, {
                            meta: {
                                width: child.meta.width + widthToBeAdded
                            }
                        } as ElementWithType, {
                            at: rowPath.concat(index)
                        })
                    }
                })
            }
        }
        return apply(operation);
    }

    return editor;
}


Registry.register(withGrid, {
    id: 'withGrid',
    registry: 'v2.plugin'
})
